<template>
  <v-layout>
    <v-dialog v-bind:value="dialog" @click:outside="$emit('updateDialog', false)" max-width="520px">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" class="mb-5" dark v-on="on" @click="$emit('updateDialog', true)">{{ button_name }}</v-btn>
      </template>

      <v-card>
        <v-form v-on:submit.prevent="createItem">
          <v-card-title>
            <span class="headline">{{ modal_title }}</span>
          </v-card-title>

          <v-card-text>
            <div class="row">
              <div class="col-md-12">
                <v-combobox
                  v-model="item.emitter"
                  data-vv-as="emisor"
                  name="emitter"
                  item-text="name"
                  item-value="id"
                  :items="emitters"
                  label="Emisor*"
                  autocomplete="off"
                  v-validate="'required|combobox_required'"
                  :disabled="isViewModal() || item.id > 0"
                  return-object
                ></v-combobox>
                <span class="red--text">{{ errors.first("emitter") }}</span>

                <v-text-field
                  data-vv-as="nombre"
                  label="Nombre*"
                  name="name"
                  v-model="item.name"
                  v-validate="'required'"
                  :disabled="isViewModal()"
                  placeholder="Ej: Ejercicio 2026"
                ></v-text-field>
                <span class="red--text">{{ errors.first("name") }}</span>

                <v-menu
                  ref="date_from_menu"
                  v-model="date_from_menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="item.date_from"
                      label="Desde*"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :disabled="isViewModal()"
                      name="date_from"
                      v-validate="'required'"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="item.date_from" no-title scrollable @input="date_from_menu = false"></v-date-picker>
                </v-menu>
                <span class="red--text">{{ errors.first("date_from") }}</span>

                <v-menu
                  ref="date_to_menu"
                  v-model="date_to_menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="item.date_to"
                      label="Hasta*"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :disabled="isViewModal()"
                      name="date_to"
                      v-validate="'required'"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="item.date_to" no-title scrollable @input="date_to_menu = false"></v-date-picker>
                </v-menu>
                <span class="red--text">{{ errors.first("date_to") }}</span>
              </div>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="$emit('updateDialog', false)">Cerrar</v-btn>
            <v-btn color="success" text type="submit" v-if="!isViewModal()" :loading="loading">{{ formBtn }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import ModalGenericMixin from "@/mixins/ModalGenericMixin.vue";
import ConstantSections from "@/constants/sections";

export default {
  mixins: [ModalGenericMixin],
  props: {
    service: Object,
    modal_title: String,
    dialog: Boolean,
    item: Object,
    button_name: String,
    formBtn: String,
    emitters: Array,
  },
  data() {
    return {
      date_from_menu: false,
      date_to_menu: false,
    };
  },
  watch: {
    item() {
      this.$emit("updateItem", this.item);
    },
    dialog() {
      this.errors.clear();
    },
  },
  methods: {
    isViewModal() {
      return this.formBtn == "";
    },
    createItem(e) {
      if (this.loading) return;
      this.$validator.validate().then((valid) => {
        if (valid) {
          e.preventDefault();
          this.loading = true;
          this.service.setSection(ConstantSections.SECTION_EJERCICIOS);

          const payload = {
            id: this.item.id || null,
            name: this.item.name,
            date_from: this.item.date_from,
            date_to: this.item.date_to,
            emitter: this.item.emitter ? { id: this.item.emitter.id } : null,
          };

          const call = this.item.id > 0 ? this.service.update(payload) : this.service.create(payload);
          call
            .then((response) => {
              if (response.status == true) {
                const verb = this.item.id > 0 ? "modifico" : "creo";
                this.$toast.success("El ejercicio se " + verb + " correctamente.", "OK");
                this.$emit("updateDialog", false);
                this.$emit("loadList");
              } else {
                this.$toast.error(response.msg || response.message, "Error");
              }
            })
            .catch(() => {
              this.$toast.error("Ocurrió un error al guardar.", "Error");
            })
            .finally(() => (this.loading = false));
        }
      });
    },
  },
};
</script>
